import axios from "axios";

import { handleUserInfo } from "@utils/authen";

const defaultOptions = { timeout: 100000 };
const axiosInstance = axios.create(defaultOptions);

axiosInstance.interceptors.request.use(
  async (config) => {
    if (
      localStorage.getItem("qovis-oversea") &&
      window.location.pathname !== "/search" &&
      (config?.method !== "get" ||
        config.url?.includes("/master/mill/get-vendor") ||
        window.location.pathname === "/")
    ) {
      const bearer_token =
        JSON.parse(localStorage.getItem("qovis-oversea") ?? "").state.user
          ?.access_token ?? "";
      if (bearer_token) {
        handleUserInfo(bearer_token);
      }
    }

    return config;
  },
  (error) => {
    return Promise.reject(new Error(error));
  },
);

export default axiosInstance;
